import { DeliveryFormSchema, DeliveryStatusSchema } from "../types/delivery";
import { BookingFormValues } from "../types/overview";
import { apis } from "service";
import { AxiosRequestConfig } from "axios";
import { CapturePaymentFormValues, PaymentStatusRequest } from "../types/payment";
import { OrderDetailResponse } from "../types/order";
import { ApproveDocumentReqType, RequestDocumenReqType, RequploadDocumentReqType, UpdateSingleProductReqType, UpdateTCSReqType } from "../types/type.api";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const update_product_status = BASE_URL + 'FiAQK2sE/accept_reject_product_v3'
const capture_payment = BASE_URL + 'FiAQK2sE/addPayment'
const edit_generic_order = BASE_URL + 'FiAQK2sE/edit_generic_order_v3' 
const update_payment = BASE_URL + 'FiAQK2sE/updatePayment'
const get_order_details = BASE_URL + 'M4Re3bq8/order_details_v3'
const get_single_generic_orders = BASE_URL + 'FiAQK2sE/generic_order_info_v3' 
const generic_order_status_update = BASE_URL + 'FiAQK2sE/status_update_generic_order_v3'
const add_delivery_address = BASE_URL + 'FiAQK2sE/addDelivery'
const update_delivery_address = BASE_URL + 'FiAQK2sE/edit_address_v3_0'
const update_forex_delivery_address = BASE_URL + 'FiAQK2sE/edit_update_delivery_v3'
const update_payment_status = BASE_URL + 'FiAQK2sE/payment_status'
const update_delivery_status = BASE_URL + 'FiAQK2sE/update_delivery_status'
const update_notes = BASE_URL + 'FiAQK2sE/edit_order_note'
const approve_documents = BASE_URL + 'FiAQK2sE/approve_reject_doc'
const tcs_update = BASE_URL + 'FiAQK2sE/EditGenericOrderDetail_v3'
const update_product = BASE_URL + 'FiAQK2sE/edit_product_detail_v3'
const request_document = BASE_URL + 'FiAQK2sE/req_doc'
const reupload_document = BASE_URL + 'FiAQK2sE/reupload_doc_v3'
const submit_document = BASE_URL + 'FiAQK2sE/submit_docs_v3'
const upload_invoices= BASE_URL + 'FiAQK2sE/upload_reupload_invoice_go_v3'
const update_service_charges = BASE_URL + 'FiAQK2sE/update_service_charge_v3'
const update_rate_and_quantity = BASE_URL + 'FiAQK2sE/update_product_rate_v3'
const approve_kyc = BASE_URL + 'FiAQK2sE/update_kyc_v3' 
const assign_card = BASE_URL + 'FiAQK2sE/forex_card_v3'
const get_card_type_data = BASE_URL + 'FiAQK2sE/card_type_v3'
const get_linked_cards = BASE_URL + 'FiAQK2sE/forex_prepaid_card_v3'
const get_all_files = BASE_URL + 'FiAQK2sE/bulk_download_v3'
const get_kyc_logs = BASE_URL + 'FiAQK2sE/kyc_log_v3'
const update_lrs_status = BASE_URL + 'FiAQK2sE/update_lrs_v3'

type StatusWithoutName = Omit<BookingFormValues["status"][number], "name">;

type BookingFormPayload = {
    order_id: number;
    status: StatusWithoutName[];
};

type UpdateRateAndQuantity ={
  "order_id": number,
  "uuid": string,
  "inr_amount": number,
  "fx_amount": number,
  "rate": number,
  "type": 'edit' | 'watch'
}

type AssignCardReqType = {
  action_type: string,
  card_number: string,
  customers_id: number,
  forex_card_id: number,
  generic_order_details_id: number,
  customer_forex_card?: number
}

export const updateProducts = async (data: BookingFormPayload) => {
  const payload: AxiosRequestConfig = {
    data
  }
  // use axios
  return await apis.post(update_product_status, payload)
};

export const capturePayment = async (data: CapturePaymentFormValues) => {
  const formData = new FormData();
  formData.append("order_details_id", data.order_details_id.toString());
  formData.append("ack_no", data.ack_no);
  formData.append("amount", data.amount.toString());
  formData.append("Payment_Proof", data.Payment_Proof);

  if (data.Supporting_document) {
    formData.append("Supporting_document", data.Supporting_document);
  }

  const payload: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };

  return await apis.post(capture_payment, payload);
}

export const updatePayment = async (data: CapturePaymentFormValues) => {

  const payload: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  return await apis.post(update_payment, payload);
}

export const getOrderDetails = async (orderId: string): Promise<OrderDetailResponse> => {
  const payload: AxiosRequestConfig = {
    params: {
      order_details_id: orderId,
    },
  };

  const response = await apis.get(get_order_details, payload);
  return response.data as OrderDetailResponse;
}

export const getGenericOrderDetails = async (orderId: string): Promise<OrderDetailResponse> => {
  const payload: AxiosRequestConfig = {
    params: {
      order_id: orderId,
    },
  };

  const response = await apis.get(get_single_generic_orders, payload);
  return response.data as OrderDetailResponse;
}

export const updateGenericOrderStatus = async (data: { order_id: number, status: string }): Promise<any> => {
  const payload: AxiosRequestConfig<{ order_id: number, status: string }> = {
    data: data
  }
  return await apis.post(generic_order_status_update, payload)
}
export const addDeliveryAddress = async (id: string, data: DeliveryFormSchema) => {
  const dataToSend = {
    'delivery_detail': {
      "order_details_id": id,
      "house_number": data.address1,
      "street_number": data.address2,
      "City": data.city,
      "country": data.country,
      "landmark": data.landmark,
      "State": data.state,
      "pincode": data.pincode,
      "delivered_by": data.delivery_channel,
      "delivery_mode": data.delivery_mode,
      "delivery_id": data.delivery_id,
      "tracking_id": data.tracking_id,
      "product_id": data.products,
      "customers_id": data.customers,
      'address_id': data.address_id || ''
    }
  }
  const payload: AxiosRequestConfig = {
    data: dataToSend,
  }
  // use axios
  return await apis.post(add_delivery_address, payload)
}

export const updateDeliveryAddress = async (id: string, data: (DeliveryFormSchema & {uuid:string})) => {

  const dataToSend = {
    "house_number": data?.address1,
    "street_number": data?.address2,
    "City": data?.city,
    "country": data?.country,
    "landmark": data?.landmark,
    "State": data?.state,
    "pincode": data?.pincode,
    "address_id": data?.address_id,
    "generic_order_details_id": id,
    "delivery_mode": data?.delivery_mode,
    "delivery_id": data?.delivery_id,
    "tracking_id": data?.tracking_id,
    "generic_delivery_id": data?.uuid
  }
  const payload: AxiosRequestConfig = {
    data: dataToSend,
  }
  // use axios
  return await apis.post(update_delivery_address, payload)
}

export const editGenericOrder = async (data: {
  order_id: number;
  lead_id: number;     
  assign_to: number;        
 
}) => {
  const payload: AxiosRequestConfig = {
    data: data,
  }
  return await apis.post(edit_generic_order, payload)
}

export const updatePaymentStatus = async (data: PaymentStatusRequest) => {
  const payload: AxiosRequestConfig = {
    data
  }
  return await apis.post(update_payment_status, payload)
}

export const updateDeliveryStatus = async (order_id: string, delivery_id: string, data: DeliveryStatusSchema) => {
  const dataToSend = {
    "order_details_id": Number(order_id),
    "status_update": {
      "delivery_id": delivery_id,
      "status": data?.status,
      "date": data?.date,
      "quantity" : data?.quantity,
      "assign_to": Number(data?.assign_to)
    }
  }
  const payload: AxiosRequestConfig = {
    data: dataToSend
  }
  return await apis.post(update_delivery_status, payload)
}

export const updatedForexOrderAddress = async (
  data: {
    house_number: string;
    street_number: string;
    City: string;
    country: string;
    landmark: string;
    State: string;
    pincode: string;
    address_id: string;
    order_id:number;
    status_update: {
      delivery_id: string;
      status: string;
      date: string;
      quantity: number;
      assign_to: number;
    };
  }
) => {
  const dataToSend = {
    ...data,
  };

  const payload: AxiosRequestConfig = {
    data: dataToSend,
  };

  try {
    const response = await apis.post(update_forex_delivery_address, payload);
    return response?.data;
  } catch (error) {
    console.error("Error updating forex delivery address:", error);
    throw error;
  }
};


export const updateNotes = async ({ order_id, notes }: { order_id: string, notes: string }) => {
  const data = {
    "order_details_id": order_id,
    "notes": notes
  }
  const payload: AxiosRequestConfig = {
    data
  }
  return await apis.post(update_notes, payload)
}

export const approveDocuments = async (data: ApproveDocumentReqType) => {
  const payload: AxiosRequestConfig<ApproveDocumentReqType> = {
    data
  }
  return await apis.post(approve_documents, payload)
}

export const updateTcs = async (data: UpdateTCSReqType) => {
  const payload: AxiosRequestConfig<UpdateTCSReqType> = {
    data: data
  }
  return await apis.patch(tcs_update, payload)
}

export const updateProductSingle = async (data: UpdateSingleProductReqType): Promise<any> => {
  const payload: AxiosRequestConfig<UpdateSingleProductReqType> = {
    data: data
  }
  return await apis.patch(update_product, payload)
}

export const requestDocument = async (data: RequestDocumenReqType): Promise<any> => {
  const payload: AxiosRequestConfig<RequestDocumenReqType> = {
    data: data
  }
  return await apis.post(request_document, payload)
}

export const reuploadDocument = async (data: RequploadDocumentReqType): Promise<any> => {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (key === 'doc') {
        formData.append(key, value as string); // Assuming value is a Base64URLString
      } else if (key === 'additional_doc') {
        const additionalDocs = Array.isArray(value) ? value : [value];
        additionalDocs.forEach((doc) => {
          formData.append('additional_doc[]', JSON.stringify(doc));
        });
      } else {
        formData.append(key, value.toString());
      }
    }
  });

  const payload: AxiosRequestConfig<FormData> = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };

  return await apis.post(reupload_document, payload);
}

export const submitDocument = async (data: { order_details_id: number }): Promise<any> => {
  const payload: AxiosRequestConfig<{
    order_id: number;
  }> = {
    data: {
      order_id: data.order_details_id,
    },
  };

  return await apis.post(submit_document, payload);
}

export const uploadInvoices = async (data: {
  generic_order_details_id?: number;
  doc_id?: number;
  invoice: string;
  doc_uuid?: string;
  customers_id?: number;
}) => {
  const formData = new FormData();
  formData.append("generic_order_details_id", data.generic_order_details_id?.toString() || '');
  formData.append("doc_id", '71');
  formData.append("invoice", data.invoice);
  formData.append("doc_uuid", data.doc_uuid?.toString() || '');
  formData.append("customers_id", data.customers_id?.toString() || '');

  const payload: AxiosRequestConfig<FormData> = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };

  return await apis.post(upload_invoices, payload);
}

export const updateServiceCharges = async (data: { order_id: number, amount: number }): Promise<any> => {
  const payload: AxiosRequestConfig<{ order_id: number, amount: number }> = {
    data: data
  }
  return await apis.post(update_service_charges, payload)
}

export const updateRateAndQuantity = async (data: UpdateRateAndQuantity): Promise<any> => {
  const payload: AxiosRequestConfig<UpdateRateAndQuantity> = {
    data: data
  }
  return await apis.post(update_rate_and_quantity, payload)
}

export const approveKyc = async (data: {customers_id:number}) => {
  const payload: AxiosRequestConfig<{ customers_id: number }> = {
    data: data
  }
  return await apis.post(approve_kyc, payload)
}

export const assignCard = async (data: AssignCardReqType): Promise<any> => {
  const payload: AxiosRequestConfig<AssignCardReqType> = {
    data: data
  }
  return await apis.post(assign_card, payload)
}

export const getCardTypeData = async (data: {action_type: string}): Promise<{id: number, card_company: string, card_type: string}[]> => {
  const payload: AxiosRequestConfig = {
    params: data
  }
  const response = await apis.get(get_card_type_data, payload)
  return response.data
}

export const getLinkedCards = async (data: {customers_id: number}): Promise<{id: number, card_number: string, card_status: string, forex_card_id: number, card_company: string, action_type: string, card_holder: number}[]> => {
  const payload: AxiosRequestConfig = {
    params: data
  }
  const response = await apis.get(get_linked_cards, payload)
  return response.data
}

export const getAllFiles = async (data: {order_id: number}): Promise<{id: number, doc_name: string, document: {name: string, url: string, type: string, mime: string} }[]> => {
  const payload: AxiosRequestConfig = {
    params: data
  }
  const response = await apis.get(get_all_files, payload)
  return response.data
}

export const getKycLogs = async (data: {customers_id: number}): Promise<{id: number, created_at: string, status: string, customers_id: number, verified_by: number}[]> => {
  const payload: AxiosRequestConfig = {
    params: data
  }
  const response = await apis.get(get_kyc_logs, payload)
  return response.data
}

export const updateLrsStatus = async (data: {order_id: number}): Promise<void> => {
  const payload: AxiosRequestConfig<{ order_id: number, lrs_signed: boolean }> = {
    data: data
  }
  await apis.post(update_lrs_status, payload)
}
